module.exports = __webpack_public_path__ + "img/peach-min.7ba88adb.png";